import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
type ProjectFormRadioOptionProps = {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  id: string;
  label?: string;
  value: string;
};
function projectFormRadioOptionClassName({
  className,
  disabled = false
}: {
  className?: string;
  disabled?: boolean;
} = {}) {
  return cn("flex min-h-10 cursor-pointer items-center gap-3 rounded-lg border px-4 py-2 transition-colors", "border-input hover:bg-muted/50", "has-data-checked:border-primary has-data-checked:bg-primary/5", "has-[:focus-visible]:ring-ring/50 has-[:focus-visible]:ring-2", disabled && "cursor-not-allowed opacity-60", className);
}
export function ProjectFormRadioOption(t0) {
  const $ = _c(15);
  const {
    children,
    className,
    disabled: t1,
    id,
    label,
    value
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className || $[1] !== disabled) {
    t2 = projectFormRadioOptionClassName({
      className: cn("h-10 py-0", className),
      disabled
    });
    $[0] = className;
    $[1] = disabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== disabled || $[4] !== id || $[5] !== value) {
    t3 = <RadioGroupItem disabled={disabled} id={id} value={value} />;
    $[3] = disabled;
    $[4] = id;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== label) {
    t4 = children ?? <span className="font-medium">{label}</span>;
    $[7] = children;
    $[8] = label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== id || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <label className={t2} htmlFor={id}>{t3}{t4}</label>;
    $[10] = id;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}